mutation SetEmployeeLeaving($employeeId: ID!, $leftOn: ISO8601Date) {
  setEmployeeLeaving(input: { employeeId: $employeeId, leftOn: $leftOn }) {
    employee {
      id
      leftOn
      worksAtFp
    }
  }
}
